import { useState } from "react";
import { useTranslation } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { updateStatusCloseDetails } from "../../../../../apis";
import { SubmitButtons } from "./CloseReport";

export const ClosedInadmissible = ({
  id,
  reportDetail,
  closeDate,
  reportExpired,
  reportRender,
  editClosed,
  setEditClosed,
}) => {
  const [t] = useTranslation("report");

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    enqueueSnackbar(`${t("Conclusion.sending")}...`, { variant: "info" });

    try {
      const details = {
        another_causes: [],
        followup: false,
        closed: "inadmissible",
        close_date: closeDate,
        causes: [],
        observations: "",
        files: [],
        expired_reports: reportExpired,
      };

      await updateStatusCloseDetails(id, details);
      enqueueSnackbar(`${t("Conclusion.sending_successful")}`, {
        variant: "success",
      });
      reportRender();
      setIsLoading(false);
      setEditClosed(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  return (
    <SubmitButtons
      isLoading={isLoading}
      onSave={handleSubmit}
      onCancel={() => setEditClosed(false)}
      hideCancel={!editClosed}
    />
  );
};
